<template>
  <v-container>
    <v-layout class="title-section">
      Service Tickets
    </v-layout>
    <h2>Listado</h2>
    <v-flex d-flex align-center class="max-min-width-up">
      <p class="max-min-width">
        Seleccione por favor el número de ODS a consultar.
      </p>
      <v-select
        v-model="odsSelected"
        :items="ods"
        box
        label="Seleccionar ODS"
        color="#466EA5"
        @change="fetchODSInfo(odsSelected)"
      >
      </v-select>
    </v-flex>

    <v-flex
      v-if="odsSelected !== null && loadedODS.length === 0"
      class="max-min-width"
    >
      <h3>
        Por el momento no hay ningún Service Ticket para la ODS:
        <b>{{ odsSelected }}</b>
      </h3>
    </v-flex>

    <v-divider
      v-if="loadedODS.length > 0 || loadedODSCurrentRealMonth.length > 0"
    />
    <v-flex
      d-flex
      v-if="loadedODS.length > 0 || loadedODSCurrentRealMonth.length > 0"
      pt-2
    >
      <!-- LEFT SIDE -->
      <v-flex class="max-min-width">
        <!-- ST MONTH -->
        <v-flex pb-2>
          <h3 class="font-weight-bold">
            {{ currentSTMonth }}
          </h3>
          <v-flex>
            <h2>
              {{ `ODS: ${odsSelected}` }}
            </h2>
            <h3>
              {{ `Service Tickets: ${loadedODS.length}` }}
            </h3>
          </v-flex>

          <v-flex pt-2>
            <!-- @change="loadODSInfo(loadedODS)" -->
            <v-select
              v-model="userSelected"
              :items="loadedODS"
              item-text="user"
              box
              clearable
              label="Seleccionar Usuario"
              color="#466EA5"
              @click:clear="clearLoadedInfo"
              @input="userSelectedInput"
              return-object
            >
            </v-select>
          </v-flex>
          <!-- ACTIONS MESSAGES -->
          <v-flex v-if="userSelected !== null && userSelected !== undefined">
            <v-flex v-if="userSelected.approved === 0">
              <v-flex v-if="role === 2">
                <v-btn
                  class="text-capitalize"
                  color="#466EA5"
                  block
                  dark
                  @click="
                    sendODSConfirm({
                      uid: userSelected.uid,
                      userUID: userSelected.userUID,
                      month: userSelected.month,
                      year: userSelected.year
                    })
                  "
                >
                  <font-awesome-icon
                    class="mr-2"
                    :style="{ color: '#FFFFFF' }"
                    size="lg"
                    :icon="['fal', 'check-circle']"
                  />
                  Aprobar
                </v-btn>
              </v-flex>
              <v-flex v-if="role === 2" pt-2>
                <v-btn
                  class="text-capitalize"
                  color="red darken-1"
                  block
                  dark
                  @click="sendODSConfirmNOA(userSelected.uid)"
                >
                  <font-awesome-icon
                    class="mr-2"
                    :style="{ color: '#FFFFFF' }"
                    size="lg"
                    :icon="['fal', 'exclamation-triangle']"
                  />
                  No Aprobar
                </v-btn>
              </v-flex>
            </v-flex>

            <v-flex
              v-else-if="userSelected.approved === 1"
              class="message-green"
              d-inline-flex
              align-center
              pl-2
            >
              <font-awesome-icon
                :style="{ color: '#00E676' }"
                size="2x"
                :icon="['fal', 'check-circle']"
              />
              <h5 class="color-green pl-3">Aprobado</h5>
            </v-flex>

            <v-flex
              v-else-if="userSelected.approved === 2"
              class="message-red"
              d-inline-flex
              align-center
              pl-2
            >
              <font-awesome-icon
                :style="{ color: '#E53935' }"
                size="2x"
                :icon="['fal', 'exclamation-triangle']"
              />
              <v-flex>
                <h5 class="color-red pl-3">No Aprobado</h5>
                <h3 class="pl-3">En revisión</h3>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- CURRENT MONTH -->
        <v-divider v-if="loadedODSCurrentRealMonth.length > 0" />
        <v-flex v-if="loadedODSCurrentRealMonth.length > 0" pt-2>
          <v-flex>
            <h3 class="font-weight-bold">
              {{ currentRealMonth }}
            </h3>
            <v-flex>
              <h2>
                {{ `ODS: ${odsSelected}` }}
              </h2>
              <h3>
                {{ `Service Tickets: ${loadedODSCurrentRealMonth.length}` }}
              </h3>
            </v-flex>
          </v-flex>

          <v-flex pt-2>
            <!-- @change="loadODSInfo(loadedODS)" -->
            <v-select
              v-model="userSelectedNext"
              :items="loadedODSCurrentRealMonth"
              item-text="user"
              box
              clearable
              label="Seleccionar Usuario"
              color="#466EA5"
              @click:clear="clearLoadedInfo"
              @input="userSelectedInputNext"
              return-object
            >
            </v-select>
          </v-flex>
          <!-- ACTIONS MESSAGES -->
          <v-flex
            v-if="userSelectedNext !== null && userSelectedNext !== undefined"
          >
            <v-flex v-if="userSelectedNext.approved === 0">
              <v-flex v-if="role === 2">
                <v-btn
                  class="text-capitalize"
                  color="#466EA5"
                  block
                  dark
                  @click="
                    sendODSConfirm({
                      uid: userSelectedNext.uid,
                      userUID: userSelectedNext.userUID,
                      month: userSelectedNext.month,
                      year: userSelectedNext.year
                    })
                  "
                >
                  <font-awesome-icon
                    class="mr-2"
                    :style="{ color: '#FFFFFF' }"
                    size="lg"
                    :icon="['fal', 'check-circle']"
                  />
                  Aprobar
                </v-btn>
              </v-flex>
              <v-flex v-if="role === 2" pt-2>
                <v-btn
                  class="text-capitalize"
                  color="red darken-1"
                  block
                  dark
                  @click="sendODSConfirmNOA(userSelectedNext.uid)"
                >
                  <font-awesome-icon
                    class="mr-2"
                    :style="{ color: '#FFFFFF' }"
                    size="lg"
                    :icon="['fal', 'exclamation-triangle']"
                  />
                  No Aprobar
                </v-btn>
              </v-flex>
            </v-flex>

            <v-flex
              v-else-if="userSelectedNext.approved === 1"
              class="message-green"
              d-inline-flex
              align-center
              pl-2
            >
              <font-awesome-icon
                :style="{ color: '#00E676' }"
                size="2x"
                :icon="['fal', 'check-circle']"
              />
              <h5 class="color-green pl-3">Aprobado</h5>
            </v-flex>

            <v-flex
              v-else-if="userSelectedNext.approved === 2"
              class="message-red"
              d-inline-flex
              align-center
              pl-2
            >
              <font-awesome-icon
                :style="{ color: '#E53935' }"
                size="2x"
                :icon="['fal', 'exclamation-triangle']"
              />
              <v-flex>
                <h5 class="color-red pl-3">No Aprobado</h5>
                <h3 class="pl-3">En revisión</h3>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- RIGHT SIDE -->
      <v-layout
        v-if="
          (userSelected !== null && userSelected !== undefined) ||
            (userSelectedNext !== null && userSelectedNext !== undefined)
        "
        class="max-min-width-c pl-5"
        column
      >
        <!-- COMMENTS -->
        <!-- USER SELECTED -->
        <v-flex
          v-if="userSelected !== null && userSelected !== undefined"
          class="comments-container"
          pa-3
        >
          <h3>Comentarios Empleado</h3>
          {{
            userSelected.comments !== ""
              ? userSelected.comments
              : "No hay comentarios por parte del empleado."
          }}
        </v-flex>
        <!-- USER SELECTED NEXT -->
        <v-flex
          v-else-if="
            userSelectedNext !== null && userSelectedNext !== undefined
          "
          class="comments-container"
          pa-3
        >
          <h3>Comentarios Empleado</h3>
          {{
            userSelectedNext.comments !== ""
              ? userSelectedNext.comments
              : "No hay comentarios por parte del empleado."
          }}
        </v-flex>
        <!-- CALENDAR -->
        <v-layout class="calendar-container" pa-3 mt-1>
          <v-flex>
            <v-flex d-inline-flex align-baseline>
              <v-flex>
                <h2>
                  {{ currentMonth }}
                </h2>
              </v-flex>
              <v-flex pl-2>
                <h3>
                  <b>{{ currentYear }}</b>
                </h3>
              </v-flex>
            </v-flex>
            <v-sheet height="500">
              <v-calendar
                ref="calendar"
                v-model="start"
                :end="end"
                :type="type"
                color="#C46D24"
                locale="es-co"
                @click:date="inputDate"
                @moved="movedDate"
              >
                <template v-slot:day="{ date }">
                  <v-flex
                    v-for="(event, index) in eventsMap[date]"
                    :key="index"
                  >
                    <!-- RESTRICTION DATE EVENTS -->
                    <v-flex
                      v-if="event.ods === 'NA'"
                      class="restriction-dates-in-calendar"
                      px-1
                    >
                      - NA
                    </v-flex>
                    <!-- END DATE EVENT -->
                    <v-flex
                      v-if="event.ods === 'endDate'"
                      class="end-date-in-calendar"
                      px-1
                      mb-1
                    >
                      Fecha de Retiro
                    </v-flex>
                    <!-- START DATE EVENT -->
                    <v-flex
                      v-if="event.ods === 'startDate'"
                      class="start-date-in-calendar"
                      px-1
                      mb-1
                    >
                      Fecha de Inicio
                    </v-flex>
                    <!-- ROLE 1  -->
                    <v-flex v-if="role === 1 && event.ods === 'holy'">
                      <v-flex class="holy-in-calendar" px-1 mb-1>
                        *Festivo
                      </v-flex>
                      <v-flex class="ods-in-calendar" px-1>
                        {{ optionsODS[event.ods] }}
                      </v-flex>
                    </v-flex>
                    <!-- ALL EVENTS -->
                    <v-flex
                      v-else-if="
                        event.ods !== 'holy' &&
                          event.ods !== 'X' &&
                          event.odsN !== 'XR'
                      "
                      class="ods-in-calendar"
                      px-1
                    >
                      {{ optionsODS[event.ods] }}
                    </v-flex>
                    <!-- HOLY DAYS -->
                    <v-flex
                      v-else-if="event.ods === 'holy'"
                      class="holy-in-calendar"
                      px-1
                      mb-1
                    >
                      *Festivo
                    </v-flex>
                    <!-- REMOTE WORK -->
                    <v-flex
                      v-else-if="event.odsN === 'XR'"
                      class="xr-in-calendar"
                      px-1
                      mb-1
                    >
                      XR - Base de Trabajo Remoto
                    </v-flex>
                    <!-- X -->
                    <v-flex v-else class="x-in-calendar" px-1 mb-1>
                      X - Base de Trabajo
                    </v-flex>
                  </v-flex>
                </template>
              </v-calendar>
            </v-sheet>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TheODS",
  data() {
    return {
      userSelectedNext: null,
      events: [],
      optionsODS: [
        "XR - Base de Trabajo Remoto",
        "C - Comisión",
        "PL - Permiso Legal",
        "PNR - Permiso no remunerado",
        "I - Incapacidad",
        "D - Descanso"
      ],
      type: "month",
      odsSelected: null,
      userSelected: null
      // userODSSelected: null
    };
  },
  computed: {
    ...mapGetters([
      "currentMonthNumber",
      "currentSTMonth",
      "currentRealMonth",
      "loadedODSCurrentRealMonth",
      "currentYear",
      "currentMonth",
      "startCalendar",
      "endCalendar",
      "holyDays",
      "ods",
      "loadedODS",
      "role"
    ]),
    start: {
      get() {
        return this.startCalendar;
      },
      set(value) {
        return value;
      }
    },
    end: {
      get() {
        return this.endCalendar;
      },
      set(value) {
        return value;
      }
    },
    // userODSSelected() {
    //   if (this.userSelected !== null || this.userSelected !== undefined) {
    //     const ods = this.loadedODS.find(
    //       item => item.user === this.userSelected
    //     );
    //     // this.userODSSelected = ods;
    //     console.log("ODS: ", ods);
    //     if (ods !== undefined) return ods;
    //     else return [];
    //   } else return [];
    // },
    eventsMap() {
      const map = {};
      if (this.userSelected !== undefined)
        this.events.forEach(e => (map[e.date] = map[e.date] || []).push(e));
      return map;
    }
  },
  methods: {
    ...mapActions(["fetchODSInfo", "showGeneralMessage"]),
    userSelectedInputNext() {
      this.userSelected = null;
      if (this.userSelectedNext !== undefined) {
        this.$store.commit("CHANGE_CURRENT_MONTH_LF");
        this.$store.commit("SET_START_END_CALENDAR");
        this.$store.commit("SET_HOLY_DAYS");
        this.events = [...this.holyDays, ...this.userSelectedNext.events];
      }
    },
    userSelectedInput() {
      this.userSelectedNext = null;
      if (this.userSelected !== undefined) {
        this.$store.commit("CHANGE_CURRENT_REAL_MONTH_LF");
        this.$store.commit("SET_START_END_CALENDAR");
        this.$store.commit("SET_HOLY_DAYS");
        this.events = [...this.holyDays, ...this.userSelected.events];
      }
    },
    clearLoadedInfo() {
      // console.log("CLEAR!", this.userSelected);
      this.userSelected = null;
      // console.log("CLEAR!", this.userSelected);
    },
    movedDate() {
      // console.log("MOVED DATE: ", date);
      this.start = this.startCalendar;
      this.end = this.endCalendar;
    },
    inputDate(date) {
      // console.log("TESTING EVENTS", date.month);
      if (date.month !== this.currentMonthNumber) {
        // console.log("NOT ALLOWED");
        this.$refs.calendar.move();
      }
    },
    sendODSConfirmNOA(uid) {
      // console.log("KEY: ", this.userSelected.uid);
      const payload = {
        showMessage: true,
        showTextArea: true,
        messagesComments:
          "Por favor ingrese los comentarios indicando el motivo, o los motivos de la No Aprobación.",
        showCancelBtn: true,
        showSendBtn: true,
        showOkBtn: false,
        action: "noAODS",
        data: uid,
        messageTitle: "Confirmar No Aprobado",
        messageInfo:
          "Esta a punto de No Aprobar un Service Ticket; por favor confirmar enviando, o cancelar sí es el caso."
      };
      this.showGeneralMessage(payload);
      // this.sendODS(this.events);
    },
    sendODSConfirm(data) {
      // console.log("sendODSConfirm: ", data);
      const payload = {
        showMessage: true,
        showCancelBtn: true,
        showSendBtn: true,
        showOkBtn: false,
        action: "okODS",
        data: data,
        messageTitle: "Confirmar Aprobado",
        messageInfo:
          "Esta a punto de Aprobar un Service Ticket; por favor confirmar enviando, o cancelar sí es el caso."
      };
      this.showGeneralMessage(payload);
      // this.sendODS(this.events);
    }
    // odsToShow() {
    //   if (this.userSelected !== null) {
    //     const ods = this.loadedODS.find(item => item.user = this.userSelected);
    //     this.userODSSelected = ods;
    //     console.log("ODS: ", ods);
    //     return ods;
    //   } else return [];
    // },
    // loadODSInfo(user) {
    //   console.log("LOAD ODS INFO: ", user);
    // }
  }
};
</script>

<style lang="stylus" scoped>
h5
  font-size 21px
  font-weight 500

.restriction-dates-in-calendar
  background-color #757575
  background-image url('../assets/pattern-2.svg')
  background-repeat repeat
  color #BDBDBD
  border-radius 2px
  cursor not-allowed

.end-date-in-calendar
  background-color #F44336
  color white
  border-radius 2px
  cursor pointer

.start-date-in-calendar
  background-color #4CAF50
  color white
  border-radius 2px
  cursor pointer

.max-min-width-up
  max-width 580px
  min-width 580px

.calendar-container
  background-color #F5F5F5
  border-radius 8px

.comments-container
  background-color #E0E0E0
  border-radius 8px
  // margin-left 24px

.message-red
  height 70px
  // padding-bottom 40px
  padding-left 10px
  padding-right 10px
  border  solid 2px #E53935
  border-radius 8px

.message-green
  height 40px
  // padding-bottom 45px
  padding-left 10px
  padding-right 10px
  border solid 2px #00E676
  border-radius 8px

.color-green
  color #00E676

.color-red
  color #E53935

.title-section
  font-size 40px
  font-weight 700
  color #C46D24

.max-min-width-c
  max-width 1024px
  min-width 1024px

.max-min-width
  max-width 290px
  min-width 290px

.ods-in-calendar
  background-color #C46D24
  color white
  border-radius 2px
  cursor pointer

.x-in-calendar
  background-color #466EA5
  color white
  border-radius 2px
  cursor pointer

.xr-in-calendar
  background-color #5E35B1
  color white
  border-radius 2px
  cursor pointer

.holy-in-calendar
  background-color #BDBDBD
  color white
  border-radius 2px
  cursor pointer
</style>
